import { Component, h } from 'preact'
import EmptyPage from '../empty-page/EmptyPage'
import Header from '../header'
import Table from '../table/Table'
import Icon from '../assets'
import { featuredTopicsInfoType } from './GroupFeaturedTopics'
import { FeaturedTopic } from '../featured-topics/FeaturedTopics'
import { common } from '../common'

export type ImageData = {
  source_thumb: string,
  source: string,
  type: string,
  bbcode_url:string,
  short_url: string,
  short_thumb_url: string
}

export interface GroupData {
  id?: number,
  url?: string,
  title: string,
  groupType?:number,
  membersCount?: number,
  applicantsCount?: number | 'N/A',
  type?:number,
  visibleTopics?:number,
  description: string,
  heroImage: null | ImageData,
  thumbnailImage: null | ImageData,
  featuredTopicsInfo?: undefined | featuredTopicsInfoType,
  isPrivateGroup?: boolean,
  contentCuration?: null | {
    title: string,
    curatedTopics: Array<FeaturedTopic>
  },
  seoTitle: string,
  seoDescription: string
}

interface Props {
  groups: Array<GroupData>,
  defaultCdn: string
}

interface State {
}

export class GroupsOverview extends Component<Props, State> {
  render ({ groups, defaultCdn }: Props) {
    const model = common.isModuleActive('privateGroup') ? [{
      header: 'Group name',
      accessor: 'title'
    },
    {
      header: 'Visibility',
      accessor: 'visibility'
    },
    {
      header: 'Members',
      accessor: 'members'
    },
    {
      header: 'Applications',
      accessor: 'applications'
    }] : [{
      header: 'Group name',
      accessor: 'title'
    },
    {
      header: 'Members',
      accessor: 'members'
    }]
    const rows = groups.map((group: GroupData) => (
      {
        title: <div className='group-overview_title'>
          <a href={`/platform/group/${group.id}`} >{ group.title }</a>
          <a target='_blank' href={group.url}><Icon size={16} icon='externalLink' /></a>
        </div>,
        visibility: !group.isPrivateGroup ? 'Public' : 'Private',
        members: group.membersCount,
        applications: !group.isPrivateGroup ? 'N/A' : group.applicantsCount
      }
    ))

    return (
      <div className='group-overview-page'>
        <Header
          title='Groups'
          disableCancelButton
          disableSaveButton
          customButtons={groups.length ? (
            [{
              title: 'New group',
              variant: 'brand',
              newStyle: true,
              action: () => window.location.assign('/platform/group/add')
            }]
          ) : []}
        />
        {
          !groups.length ? (
            <EmptyPage
              img_src={`${defaultCdn}/images/empty_groups.png`}
              header='No groups found'
              text={'Seems like no one on your team has created any group. \n Start now by creating a new group.'}
              button={{ link: '/platform/group/add', text: 'New group' }}
            />
          ) : (
            <Table firstColumnSticky model={model} rows={rows} />
          )
        }
      </div>
    )
  }
}

export default GroupsOverview
